module.exports = __webpack_public_path__ + "img/DE05572.9036a69a.png";